import { Checkbox } from 'primereact/checkbox';
import { Dropdown, type DropdownProps } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import './form-input.styles.css';

type Option = {
	name: string;
	code: string | number | boolean | object;
};

const DropDownCheckbox = (props: DropdownProps) => {
	const { options, value, ...rest } = props;

	const optionTemplate = (option: Option) => (
		<div
			style={{
				justifyContent: 'space-between',
				display: 'flex',
			}}
		>
			<span>{option.name}</span>
			<Checkbox
				checked={value?.code === option.code}
				pt={{
					root: {
						className: 'hover:bg-transparent',
					},
					box: {
						className: classNames('ddc-checkbox-input', {
							'ddc-checkbox-input-checked':
								value?.code === option.code,
						}),
					},
					icon: {
						className: 'ddc-checkbox-icon',
					},
				}}
			/>
		</div>
	);

	const selectedOptionTemplate = (option: Option) => {
		if (option) {
			return <span>{option.name}</span>;
		}
	};

	return (
		<Dropdown
			{...rest}
			options={options}
			value={value}
			itemTemplate={optionTemplate}
			valueTemplate={selectedOptionTemplate}
			pt={{
				itemLabel: {
					className: 'ddc-option-label',
				},
			}}
		/>
	);
};

export default DropDownCheckbox;
